import * as React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import GrainIcon from "@mui/icons-material/Grain";
import { useNavigate } from "react-router-dom";

function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

export default function NavBreadcrumbs() {
  let navigate = useNavigate();
  return (
    <div
      role="presentation"
      onClick={handleClick}
      className="app-nav-breadcrumbs"
    >
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="#0153a4"
          href="/"
          onClick={(e) => {
            navigate("/", { replace: false });
          }}
        >
          <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="#767676"
        >
          Kitchen Equipments
        </Typography>
      </Breadcrumbs>
    </div>
  );
}
